module.exports = __webpack_public_path__ + "img/1460100736.c0235ec6.jpg";